export function sbsysaccordion() {
	if (jQuery(".js-accordion-item-agenda").length == 0) {
		return;
	}
	jQuery(document).on("click", ".js-accordion-item-agenda", function (e) {
		var folderId = jQuery(this).data("listid");
		var pageUrl = jQuery(this).data("pageurl");
		var elementId = jQuery(this).data("elementid");
		var accordionBodyContents = jQuery(this)
			.closest(".js-accordion-item")
			.find(".accordion-body__contents");
		var hasList = accordionBodyContents.find(".list__links");
		if (hasList.length) {
			return;
		}
		var loadingSpinner = accordionBodyContents.find(".lds-default");
		if (loadingSpinner) {
			loadingSpinner.css("display", "inline-block");
		}
		var requestData = {
			folderId: folderId,
			pageUrl: pageUrl,
			elementId: elementId,
		};
		console.log(requestData);
		fetch(
			"/surface/AgendaSurface/GetAgendaList?" +
				new URLSearchParams(requestData),
		)
			.then(function (response) {
				if (!response.ok) {
					throw new Error("Network response was not ok");
				}
				return response.text();
			})
			.then(function (data) {
				var newData = data.trim();
				if (loadingSpinner) {
					loadingSpinner.css("display", "none");
				}
				console.log("data:", newData);
				accordionBodyContents.html(newData);
				accordionBodyContents.css("display", "block");
			})
			.catch(function () {
				console.log("Error in loaded comments");
				if (loadingSpinner) {
					loadingSpinner.css("display", "none");
				}
			});
	});

	// Aabn den accordion som URL-fragmentet peger paa — fx naar brugeren kommer tilbage
	// fra en enkelt dagsorden via "Tilbage til oversigten".
	//
	// Den generiske hash-haandtering i accordion.js springer bevidst agenda-accordions
	// over (.not(".js-accordion-item-agenda")), fordi den kun folder ud uden at hente
	// listen — det ville efterlade en evig spinner. Derfor udloeser vi et rigtigt klik,
	// saa baade udfoldningen og AJAX-hentningen ovenfor koerer.
	jQuery(window).on("load", function () {
		var urlHash = window.location.hash.substring(1);

		// Id'et dannes som "agenda" + elementid (4 hex-tegn) i AgendaList.cshtml.
		if (!/^agenda[a-z0-9]+$/i.test(urlHash)) {
			return;
		}

		var targetItem = jQuery(".js-accordion-item-agenda").filter("#" + urlHash);
		if (targetItem.length === 0) {
			return;
		}

		targetItem.find(".js-accordion-header-agenda").first().trigger("click");
		jQuery("html, body").animate({ scrollTop: targetItem.offset().top }, 700);
	});
}
export default sbsysaccordion;
